import { SrciButtonColorEnumsObj } from "../enums/SrciButtonColorEnum";
import { SrciButtonSizeEnumsObj } from "../enums/SrciButtonSizeEnum";
import { isLocaleValid } from "@payair/e-com-common-sdk/core/Validators";
/**
 * SRC button paramaters type to control content and appearance of the button.
 */
var SrciButtonParams = /** @class */ (function () {
    function SrciButtonParams() {
    }
    return SrciButtonParams;
}());
export { SrciButtonParams };
/** @internal */
export var validateSrciButtonParams = function (srciButtonParams) {
    var errorMessage = [];
    if (!srciButtonParams)
        errorMessage.push("srciButtonParams not defined");
    else {
        if (!srciButtonParams.buttonColor)
            errorMessage.push("buttonColor not defined");
        else if (!Object.values(SrciButtonColorEnumsObj).includes(srciButtonParams.buttonColor))
            errorMessage.push("wrong buttonColor value");
        if (srciButtonParams.buttonLocale && !isLocaleValid(srciButtonParams.buttonLocale)) {
            errorMessage.push("wrong buttonLocale value");
        }
        if (srciButtonParams.buttonSize !== undefined &&
            !Object.values(SrciButtonSizeEnumsObj).includes(srciButtonParams.buttonSize))
            errorMessage.push("wrong buttonSize value");
        if (srciButtonParams.buttonOnClick !== undefined && typeof srciButtonParams.buttonOnClick !== "function")
            errorMessage.push("buttonOnClick is not a function");
    }
    return errorMessage;
};
